<template>
  <v-card
    width="100%"
    outlined
    color="secondary darken-1"
    class="mb-4 d-none d-sm-block"
    :dark="this.$vuetify.theme.dark"
  >
    <v-card-title>
      <v-img
        src="@/assets/crash.png"
        max-height="195px"
        contain
        aspect-ratio="1"
      />
    </v-card-title>
    <v-card-subtitle class="text-h5 font-weight-bold nwhite--text">
      {{ ad.title }}
    </v-card-subtitle>
    <v-card-actions>
      <v-btn :href="ad.cta_link" target="_blank" rounded block>
        {{ ad.cta_text }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    ad: {
      type: Object,
      required: true
    }
  }
};
</script>
